__turbopack_context__.v({
  "main": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__main",
  "secondaryCtaWrapper": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__secondaryCtaWrapper",
});
